import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const DELETE_QUOTE = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: 'Al eliminar la lista borrará todos los SKUs que estén en ella, ¿Está seguro de eliminar el producto de su lista?',
  valueButton: 'Eliminar',
  color: CONFIRM_COLOR.WARN,
  iconSVG: CONFIRM_ICONS.WARNING
};

export const CANCEL_QUOTATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Está seguro de eliminar la cotización?',
  valueButton: 'Anular cotización',
  color: CONFIRM_COLOR.WARN,
  icon: 'notification_important'
};

export const SAVE_QUOTATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Desea grabar la cotización?',
  valueButton: 'Guardar',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.SAVE
};

export const EMIT_QUOTATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Está seguro de emitir la cotización?',
  valueButton: 'Emitir',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.NOTIFICATION
};

export const COPY_QUOTATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Está seguro de copiar la cotización?',
  valueCancelButton: 'Cancelar',
  valueButton: 'Confirmar',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.COPY
};

export const CANCEL_CURRENT_QUOTATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: 'Se realizará la copia ¿Desea cancelar la cotización actual?',
  valueCancelButton: 'Solo copiar',
  valueButton: 'Copiar y cancelar',
  color: CONFIRM_COLOR.WARN,
  iconSVG: CONFIRM_ICONS.QUESTION
};

export const SKU_DUPLICATE = {
  typeModal: TYPE_MODAL.ACCEPT,
  title: `Se encontró SKUs duplicados en un mismo despacho,
  los descuentos aplicados en un SKU duplicado serán consolidados.
   <b>Verifique el precio total </b> e intente nuevamente.`,
  valueButton: 'Entendido',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.NOTIFICATION
};

export const APPLY_GENERAL_DISCOUNT = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  superTitle: 'Aplicando descuento general de promociones',
  title: `Se borrará los descuentos manuales ingresados y
  se aplicará descuento a cada SKU.
  <b>Las promociones en una cotización en
   trabajo tienen vigencia de 1 día </b> <br>¿Desea continuar?` ,
  valueButton: 'Continuar',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.INFO
};

export const DELETE_SERVICES_ADDITIONAL = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: '¿Desea eliminar el servicio seleccionado?',
  valueButton: 'Eliminar',
  color: CONFIRM_COLOR.WARN,
  icon: 'delete_outline'
};

export const CREDIT_NONE = {
  typeModal: TYPE_MODAL.INVALID,
  title: 'Saldo de crédito insuficiente, elija otro medio de pago o consulte con el administrador',
  valueButton: 'Entendido',
  color: CONFIRM_COLOR.WARN,
  iconSVG: CONFIRM_ICONS.WARNING
};

export const APPLY_GENERAL_MARGEN = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  superTitle: 'Editar margen total',
  title: `<b>Se borrarán todos los descuento de promoción</b> y
  los descuentos manuales se modificarán al valor total del descuento que representa el margen a modificar entre el
  número de total de despachos.
  ¿Desea continuar?` ,
  valueButton: 'Continuar',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.INFO
};

export const UPDATE_DELIVERY = {
  typeModal: TYPE_MODAL.ACCEPT,
  superTitle: 'Actualización de datos',
  title: `Se actualizará las fechas disponibles de
  todos los despachos y los descuentos de promoción en caso se haya aplicado en la cotización.` ,
  valueButton: 'Entendido',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.INFO
};

export const DELETE_SHIPING = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: `¿Estas seguro que quiere eliminar el flete?` ,
  valueButton: 'Eliminar',
  color: CONFIRM_COLOR.WARN,
  icon: CONFIRM_ICONS.CANCEL
}
